<template lang="pug">
.content
    .res(:class="`r${res.x}x${res.y}`")
        Vid.vid(ref="vids" :src="vidsrc" :loop="datas[cur].loop" :endCallBack="onPlayEnd" :width="res.x" :height="res.y" :muted="curname!=='A1'") 
        
        .g0.abs.l.t(v-show="curname==='0'")
            //- .title.cont.abs(:style="`backgroundImage:url(${path}imgs/0/5.png);`")
            .title1.cont.abs.flexCenter(:style="`backgroundImage:url(${path}imgs/0/1a.png);`") Smart Customs Clearance
            .title2.cont.abs.flexCenter(:style="`backgroundImage:url(${path}imgs/0/2a.png);`") Intelligent Inspection
            .title3.cont.abs.flexCenter(:style="`backgroundImage:url(${path}imgs/0/3a.png);`") Electronic Cargo Tracking
            .title4.cont.abs.flexCenter(:style="`backgroundImage:url(${path}imgs/0/4a.png);`") Port Surveillance Center
            .title1a.cont.abs.hand.flexCenter(:style="`backgroundImage:url(${path}imgs/0/1b.png);`" @click="()=>setNam('18')") Smart Customs Clearance
            .title2a.cont.abs.hand.flexCenter(:style="`backgroundImage:url(${path}imgs/0/2b.png);`" @click="()=>setNam('19')") Intelligent Inspection
            .title3a.cont.abs.hand.flexCenter(:style="`backgroundImage:url(${path}imgs/0/3b.png);`" @click="()=>setNam('20')") Electronic Cargo Tracking
            .title4a.cont.abs.hand.flexCenter(:style="`backgroundImage:url(${path}imgs/0/4b.png);`" @click="()=>setNam('21')") Port Surveillance Center

            .box1.abs.hand(@click="()=>setNam('18')")
            .box2.abs.hand(@click="()=>setNam('19')")
            .box3.abs.hand(@click="()=>setNam('20')")
            .box4.abs.hand(@click="()=>setNam('21')")
        ul.ui
            li(
                v-for="item,id in ui" 
                :key="id" 
                :style="`backgroundImage:url(${item.src});width:${pxToRem(item.w)};height:${pxToRem(item.h)};left:${pxToRem(item.l)};top:${pxToRem(item.t)}`"
                v-show="item.vis.split('_').indexOf(curname)!==-1||item.vis===''"
                @click="()=>handleUI(item.cmd,item.arg)"
                )

        ul.hot
            li(
                v-for="item,id in hots" 
                :key="id" 
                :style="`backgroundColor:red;opacity:${hotAlpha};width:${pxToRem(item.w)};height:${pxToRem(item.h)};left:${pxToRem(item.l)};top:${pxToRem(item.t)};`"
                v-show="item.vis.split('_').indexOf(curname)!==-1||item.vis===''"
                @click="()=>handleHot(item.cmd,item.arg)"
                )
        HotPP(
            v-for="item,id in uipp" 
            :key="id"
            :bgsrc="item.src1"
            :bgsrc2="item.src2"
            :w="item.w"
            :h="item.h"
            :l="item.l"
            :t="item.t"
            :func="()=>handleUIPP(item.cmd,item.arg,id)"
            :ref="`hotpp${id}`"
            v-show="item.vis.split('_').indexOf(curname)!==-1||item.vis===''"
            )
        Breath(l=3058 t=660 v-show="curname==='21'" )
        //- Pop.pop(
        //-     ref='pop'
        //-     w=960
        //-     h=540
        //-     :src="`${path}${lang}${popnam}.mp4`"
        //- )
            .back(@click='onback()')
        
        .g1.abs.l.t(v-show="curname==='18'")
            .bt1.hand.contain(:style="`backgroundImage:url(${path}imgs/3.png);`" @click="()=>setNam('3')") 
            .bt2.hand.contain(:style="`backgroundImage:url(${path}imgs/4a.png);`" @click="()=>setNam('2')") 
            .bt3.hand.contain(:style="`backgroundImage:url(${path}imgs/18/1.png);`" @click="()=>setNam('4')") 
            .bt4.hand.contain(:style="`backgroundImage:url(${path}imgs/18/5.png);`" @click="()=>setNam('6')") 
            .bt5.hand.contain(:style="`backgroundImage:url(${path}imgs/18/4.png);`" @click="()=>setNam('8')") 
        .g1.abs.l.t(v-show="curname==='3'")
            .bt1.contain(:style="`backgroundImage:url(${path}imgs/3.png);`") 
            .bt2.hand.contain.alpha50(:style="`backgroundImage:url(${path}imgs/4a.png);`" @click="()=>setNam('2')") 
        .g1.abs.l.t(v-show="curname==='2'")
            .bt1.hand.contain.alpha50(:style="`backgroundImage:url(${path}imgs/3.png);`" @click="()=>setNam('3')") 
            .bt2.contain(:style="`backgroundImage:url(${path}imgs/4a.png);`") 

        .g1.abs.l.t(v-show="curname==='19'")
            .bt1.hand.contain(:style="`backgroundImage:url(${path}imgs/3.png);`" @click="()=>setNam('13')") 
            .bt2.hand.contain(:style="`backgroundImage:url(${path}imgs/4a.png);`" @click="()=>setNam('12')") 
        .g1.abs.l.t(v-show="curname==='13'")
            .bt1.contain(:style="`backgroundImage:url(${path}imgs/3.png);`") 
            .bt2.hand.contain.alpha50(:style="`backgroundImage:url(${path}imgs/4a.png);`" @click="()=>setNam('12')") 
        .g1.abs.l.t(v-show="curname==='12'")
            .bt1.hand.contain.alpha50(:style="`backgroundImage:url(${path}imgs/3.png);`" @click="()=>setNam('13')") 
            .bt2.contain(:style="`backgroundImage:url(${path}imgs/4a.png);`") 

        .g1.abs.l.t(v-show="curname==='20'")
            .bt1.hand.contain(:style="`backgroundImage:url(${path}imgs/3.png);`" @click="()=>setNam('22')") 
            .bt2.hand.contain(:style="`backgroundImage:url(${path}imgs/4a.png);`" @click="()=>setNam('15')") 
        .g1.abs.l.t(v-show="curname==='22'")
            .bt1.contain(:style="`backgroundImage:url(${path}imgs/3.png);`") 
            .bt2.hand.contain.alpha50(:style="`backgroundImage:url(${path}imgs/4a.png);`" @click="()=>setNam('15')") 
        .g1.abs.l.t(v-show="curname==='15'")
            .bt1.hand.contain.alpha50(:style="`backgroundImage:url(${path}imgs/3.png);`" @click="()=>setNam('22')") 
            .bt2.contain(:style="`backgroundImage:url(${path}imgs/4a.png);`") 

        Info(:w="res.x" :h="res.y" v-if="debug")
        
        .Debug(v-if="debug") {{cur}} {{lang}} {{vidsrc}} {{kw}}

</template>
<script>
//import axios from 'axios'
import FontService from '@/services/FontService'
import KeyService from '@/services/KeyService'
import SocketService from '@/services/SocketService'
import { mapMutations, mapState } from 'vuex'
import ResizeService from '@/services/ResizeService'
import Vid from '@/components/common/VidSimple4'
import HotPP from '@/components/common/HotPP'
import Breath from '@/components/common/Breath'
import Pop from '@/components/common/Pop'
import ProgressBar from '@/components/common/ProgressBar2'
import Info from '@/components/common/Info'
import basefunc from '@/components/common/basefunc'
const configdata={
    "debug":true,
    "path":"./static/A/A1/",
    "isc3":false,
    "isofficial":false,
    "startLan":"en",
    "res":{"x":3840,"y":2160},
    "datas":[
        {"name":"0","type":"mp4","loop":true,"next":"","key":"a"},
        {"name":"1","type":"mp4","loop":true,"next":"","key":"a"},
        {"name":"2","type":"mp4","loop":true,"next":"","key":"a"},
        {"name":"3","type":"mp4","loop":true,"next":"","key":"a"},
        {"name":"4","type":"mp4","loop":true,"next":"","key":"a"},
        {"name":"6","type":"mp4","loop":true,"next":"","key":"a"},
        {"name":"5","type":"mp4","loop":true,"next":"","key":"a"},
        {"name":"7","type":"mp4","loop":true,"next":"","key":"a"},
        {"name":"8","type":"mp4","loop":true,"next":"","key":"a"},
        {"name":"9","type":"mp4","loop":true,"next":"","key":"a"},
        {"name":"10","type":"mp4","loop":true,"next":"","key":"a"},
        {"name":"11","type":"mp4","loop":true,"next":"","key":"a"},
        {"name":"12","type":"mp4","loop":true,"next":"","key":"a"},
        {"name":"13","type":"mp4","loop":true,"next":"","key":"a"},
        {"name":"14","type":"mp4","loop":true,"next":"","key":"a"},
        {"name":"22","type":"mp4","loop":true,"next":"","key":"a"},
        {"name":"15","type":"mp4","loop":true,"next":"","key":"a"},
        {"name":"17","type":"mp4","loop":true,"next":"","key":"a"},
        {"name":"18","type":"mp4","loop":true,"next":"","key":"a"},
        {"name":"19","type":"mp4","loop":true,"next":"","key":"a"},
        {"name":"20","type":"mp4","loop":true,"next":"","key":"a"},
        {"name":"21","type":"mp4","loop":true,"next":"","key":"a"},
        {"name":"map","type":"mp4","loop":true,"next":"","key":"a"}

    ],
    "hotAlpha":0,
    "hots":[

        {"cmd":"hot","arg":"2","vis":"1","l":1982,"t":1920,"w":608,"h":114},

        {"cmd":"hot","arg":"17","vis":"21","l":779,"t":666,"w":2267,"h":801}

    ],
    "ui":[
        {"src":"./static/icon/hg/prev.png","cmd":"prev","arg":"","vis":"5_7_9_10","l":3336,"t":2004,"w":96,"h":96},
        {"src":"./static/icon/hg/next.png","cmd":"next","arg":"","vis":"6_5_8_9","l":3452,"t":2004,"w":96,"h":96},
        {"src":"./static/icon/hg/back.png","cmd":"back","arg":"18","vis":"1_2_3_4_5_6_7_8_9_10","l":3568,"t":2004,"w":96,"h":96},
        {"src":"./static/icon/hg/back.png","cmd":"back","arg":"19","vis":"11_12_13","l":3568,"t":2004,"w":96,"h":96},
        {"src":"./static/icon/hg/back.png","cmd":"back","arg":"20","vis":"22_15","l":3568,"t":2004,"w":96,"h":96},
        {"src":"./static/icon/hg/back.png","cmd":"back","arg":"21","vis":"17","l":3568,"t":2004,"w":96,"h":96},
        {"src":"./static/A/A1/imgs/5.png","cmd":"next","arg":"5","vis":"-1","l":3615,"t":974,"w":134,"h":212},
        {"src":"./static/A/A1/imgs/6.png","cmd":"prev","arg":"5","vis":"-1","l":54,"t":974,"w":134,"h":212},
        {"src":"./static/icon/hg/home.png","cmd":"home","arg":"","vis":"1_2_3_4_5_6_7_8_9_10_11_12_13_22_15_17_18_19_20_21","l":3684,"t":2004,"w":96,"h":96},
        {"src":"./static/icon/hg/close.png","cmd":"sock","arg":"exit","vis":"-1","l":6070,"t":30,"w":96,"h":96}

    ],
    "uipp":[
        {"src1":"./static/icon/deepcn.png","src2":"./static/icon/deepen.png","cmd":"lang","arg":"cn|en","vis":"-1","l":3740,"t":2060,"w":100,"h":100},
        {"src1":"./static/icon/deeppause.png","src2":"./static/icon/deepresume.png","cmd":"vctl","arg":"","vis":"A1","l":1790,"t":1660,"w":100,"h":100}
    ],

    "bgm":{
        "path":"","volume":0.5
    },
    "vals":[
        "奥地利|0|0|0|0|100.0|1",
"比利时|0|0|0|0|100.0|1",
"捷克|0|0|0|0|100.0|1",
"丹麦|0|0|0|0|100.0|1",
"法国|0|0|0|0|100.0|1",
"匈牙利|0|0|0|0|100.0|1",
"意大利|0|0|0|0|100.0|1",
"卢森堡|0|0|0|0|100.0|1",
"荷兰|0|0|0|0|100.0|1",
"波兰|0|0|0|0|100.0|1",
"葡萄牙|0|0|0|0|100.0|1",
"圣马力诺|0|0|4|50|97.5|20",
"斯洛伐克|0|0|0|0|100.0|1",
"斯洛文尼亚|0|0|0|0|100.0|1",
"西班牙|0|0|0|0|100.0|1",
"克罗地亚|0|0|0|0|100.0|1",
"罗马尼亚|0|0|0|0|100.0|1",
"中国香港特别行政区|1|0|19|266|95.0|29",
"瑞士|1|115|1|115|96.1|26",
"美国|1.5|175|1.5|175|92.0|39",
"美国，洛杉矶|2|175|2|175|92.0|39",
"美国，纽约|2|175|2|175|92.0|39",
"瑞典|2|55|0|0|98.0|18",
"加拿大|2|167|2|172|88.4|51",
"爱沙尼亚|2|0|0|0|99.9|17",
"挪威|2|125|2|125|97.0|22",
"斯威士兰|2|134|3|134|92.9|35",
"摩尔多瓦|3|76|4|83|92.3|38",
"科索沃|4|105|6|128|94.2|31",
"莱索托|4|150|5|150|91.9|40",
"塞尔维亚|4|47|5|52|96.6|23",
"保加利亚|4|55|1|0|97.4|21",
"不丹|5|59|5|110|94.2|30",
"博茨瓦纳|5|317|4|98|86.7|55",
"吉尔吉斯共和国|5|10|69|499|74.7|89",
"波斯尼亚和黑塞哥维那|5|70|6|109|95.7|27",
"格鲁吉亚|6|112|15|396|90.1|45",
"摩洛哥|6|156|57|228|85.6|58",
"乌克兰|6|75|32|100|80.1|74",
"西岸和加沙|6|51|6|50|86.7|54",
"立陶宛|7|58|0|0|97.8|19",
"白俄罗斯|7|65|0|0|96.5|24",
"黑山|8|85|23|306|91.9|41",
"北马其顿|9|103|8|150|93.9|32",
"阿尔巴尼亚|9|55|10|77|96.3|25",
"老挝|9|140|11|224|78.1|78",
"土耳其|10|338|7|46|91.6|44",
"新加坡|10|335|33|220|89.6|47",
"尼泊尔|11|103|11|190|85.1|60",
"突尼斯|12|375|80|596|74.6|90",
"大韩民国|13|185|6|315|92.5|36",
"肯尼亚|16|143|194|833|67.4|117",
"多米尼加共和国|16|488|24|579|83.5|66",
"中国台湾|17|335|47|340|84.9|61",
"阿塞拜疆|17|214|14|300|77.0|83",
"中国，上海|18|249|37|230|87.2|56",
"塞浦路斯|18|300|15|335|88.4|50",
"哥斯达黎加|20|450|80|500|77.6|80",
"墨西哥|20.4|400|44.2|450|82.1|69",
"墨西哥，墨西哥城|20|400|44|450|82.1|69",
"墨西哥，蒙特雷|20|400|44|450|82.1|69",
"中国|20.7|256.2|35.7|241|86.5|56",
"阿根廷|21|150|60|1,200|67.1|119",
"中国，北京|24|265|34|255|85.7|56",
"萨尔瓦多|24|128|36|128|89.8|46",
"希腊|24|300|1|0|93.7|34",
"爱尔兰|24|305|24|253|87.2|52",
"拉脱维亚|24|150|0|0|95.3|28",
"马耳他|24|370|2|230|88.9|48",
"毛里求斯|24|303|41|372|81.0|72",
"巴拿马|24|270|24|490|85.5|59",
"英国|24|280|3|0|93.8|33",
"卡塔尔|25|382|48|558|71.5|101",
"日本，大阪|26|331|24|389|85.3|57",
"塔吉克斯坦|27|313|107|223|60.9|141",
"亚美尼亚|27|100|3|0|91.7|43",
"日本|26.7|272.4|39.6|314.8|85.9|57",
"日本，东京|27|241|48|275|86.3|57",
"圣文森特和格林纳丁斯|27|335|37|311|81.0|71",
"圣卢西亚|27|718|27|842|73.9|93",
"阿拉伯联合酋长国|27|462|54|553|74.1|92",
"阿曼|28|279|39|244|84.1|64",
"海地|28|368|83|563|76.9|85",
"马来西亚|28|213|36|213|88.5|49",
"圣吉斯和尼维斯|28|340|48|540|77.4|81",
"乌兹别克斯坦|32|278|111|278|58.2|152",
"澳大利亚|36|766|39|539|70.3|106",
"巴哈马群岛|36|512|51|1,385|53.1|161",
"多米尼加|36|625|39|906|74.3|91",
"芬兰|36|213|2|0|92.4|37",
"德国|36|345|0|0|91.8|42",
"危地马拉|36|310|72|405|77.2|82",
"冰岛|36|365|24|365|86.7|53",
"以色列|36|150|64|307|83.4|67",
"密克罗尼西亚联邦|36|168|56|180|84.0|65",
"新西兰|37|337|25|367|84.6|63",
"沙特阿拉伯|37|319|72|464|76.0|86",
"瓦努阿图|38|709|126|681|59.1|148",
"巴巴多斯|41|486|81|1,776|62.8|132",
"马尔代夫|42|596|100|981|55.9|157",
"巴布亚新几内亚|42|700|72|940|65.8|125",
"菲律宾|42|456|120|690|68.4|113",
"斯里兰卡|43|366|72|300|73.3|96",
"索马里|44|495|85|952|51.6|166",
"泰国|44|223|50|233|84.6|62",
"阿富汗|48|453|96|750|30.6|177",
"玻利维亚|48|65|114|315|71.6|100",
"柬埔寨|48|375|8|240|67.3|118",
"阿拉伯埃及共和国|48|258|240|554|42.2|171",
"尼日尔|48|391|78|462|65.4|126",
"秘鲁|48|630|72|700|71.3|102",
"波多黎各自治邦（美国）|48|386|48|386|81.9|70",
"马里|48|242|98|545|73.3|95",
"巴西|49|862|30|375.0|69.9|108",
"巴西，里约热内卢|49|862|30|375|69.9|108",
"巴西，圣保罗|49|862|30|375|69.9|108",
"印度，孟买|50|231|60|273|82.2|68",
"科摩罗|51|651|70|765|66.9|120",
"埃塞俄比亚|51|172|72|120|56.0|156",
"印尼，雅加达|51|207|80|384|69.3|116",
"萨摩亚|51|1,400|84|900|57.8|154",
"汤加|52|201|26|330|72.6|97",
"印度|52.1|211.9|65.3|266.1|82.5|68",
"约旦|53|131|79|206|79.0|75",
"印度，德里|54|195|70|260|82.7|68",
"塞拉利昂|55|552|120|821|51.9|165",
"越南|55|290|56|373|70.8|104",
"斐济|56|317|35|320|77.9|79",
"印度尼西亚|56.3|211.1|99.4|382.6|67.5|116",
"牙买加|58|876|80|906|61.5|136",
"巴基斯坦|58|288|120|287|68.8|111",
"巴基斯坦，卡拉奇|58|288|120|287|68.8|111",
"巴基斯坦，拉合尔|58|288|120|287|68.8|111",
"布隆迪|59|109|154|444|47.3|169",
"巴林|59|47|42|397|78.7|77",
"乌干达|59|209|145|447|66.7|121",
"智利|60|290|54|290|80.6|73",
"马绍尔群岛|60|298|84|298|78.9|76",
"特立尼达和多巴哥|60|499|78|635|62.6|134",
"安提瓜和巴布达|61|546|61|546|68.7|112",
"塞内加尔|61|547|53|702|60.9|142",
"毛里塔尼亚|62|749|69|580|60.3|144",
"莫桑比克|66|602|9|399|73.8|94",
"俄罗斯|66|580|30|520.0|71.8|99",
"俄罗斯联邦，莫斯科|66|580|12|400|74.0|99",
"俄罗斯联邦，圣彼得堡|66|580|72|800|66.5|99",
"多哥|67|163|168|612|63.7|131",
"马达加斯加|70|868|99|595|61.0|140",
"佛得角|72|641|60|588|69.1|109",
"吉布提|72|605|118|1,055|59.4|147",
"几内亚|72|778|79|809|47.8|167",
"圭亚那|72|468|84|265|58.3|151",
"基里巴斯|72|420|96|685|62.1|135",
"利比亚|72|575|79|637|64.7|129",
"尼加拉瓜|72|240|72|400|77.0|84",
"布吉纳法索|75|261|102|265|66.6|122",
"印尼，苏腊巴亚|75|225|168|376|61.3|116",
"贝宁|78|354|82|599|68.9|110",
"马拉维|78|243|55|143|65.3|127",
"阿尔及利亚|80|593|210|409|38.4|172",
"塞舌尔群岛|82|332|97|341|71.8|98",
"圣多美和普林西比|83|426|150|406|66.0|124",
"卢旺达|83|183|74|282|75.0|88",
"科威特|84|665|72|634|52.6|162",
"苏里南|84|468|48|658|75.0|87",
"阿拉伯叙利亚共和国|84|1,113|141|828|29.8|178",
"伊拉克|85|1,118|131|644|25.3|181",
"津巴布韦|88|285|228|562|54.3|159",
"南非|92|1,257|87|676|59.6|145",
"伯利兹|96|710|30|688|68.2|114",
"厄瓜多尔|96|560|24|250|71.2|103",
"加蓬|96|1,633|84|1,320|43.9|170",
"黎巴嫩|96|480|180|790|57.9|153",
"坦桑尼亚|96|1,175|402|1,350|20.2|182",
"东帝汶|96|350|100|410|69.9|107",
"乌拉圭|96|1,038|6|500|58.4|150",
"伊朗伊斯兰共和国|101|415|141|660|66.2|123",
"格林纳达|101|1,034|37|1,256|61.5|137",
"帕劳|102|505|84|605|61.0|139",
"哈萨克斯坦|105|470|2|0|70.4|105",
"乍得|106|319|242|965|37.0|173",
"加纳|108|490|80|553|54.8|158",
"洪都拉斯|108|601|96|483|64.3|130",
"冈比亚|109|381|87|326|67.8|115",
"索罗门群岛|110|630|108|740|53.4|160",
"哥伦比亚|112|630|112|545|62.7|133",
"文莱达鲁萨兰国|117|340|48|395|58.7|149",
"几内亚比绍|118|585|84|550|59.6|146",
"纳米比亚|120|745|6|145|61.5|138",
"巴拉圭|120|815|24|500|65.1|128",
"赞比亚|120|370|120|380|56.9|155",
"尼日利亚|128.4|785.7|241.7|1,076.8|29.2|179",
"尼日利亚，卡诺|128|786|242|1,077|29.2|179",
"尼日利亚，拉各斯|128|786|242|1,077|29.2|179",
"赤道几内亚|132|760|240|985|32.0|175",
"蒙古|134|225|48|210|60.8|143",
"中非共和国|141|280|122|709|52.4|164",
"缅甸|142|432|230|457|47.7|168",
"南苏丹|146|763|179|781|26.2|180",
"安哥拉|164|825|72|1,030|36.2|174",
"孟加拉国|168|408.2|216|900|31.8|176",
"孟加拉国，吉大港|168|408|216|900|31.8|176",
"孟加拉国，达卡|168|408|216|900|31.8|176",
"苏丹|180|967|144|1,093|19.0|185",
"利比里亚|193|1,113|217|1,013|19.2|184",
"喀麦隆|202|983|271|1,407|16.0|186",
"象牙海岸|239|423|125|456|52.4|163",
"刚果共和国|276|1,975|397|1,581|19.7|183",
"刚果民主共和国|296|2,223|336|3,039|3.5|187",
"厄立特里亚|NoPractice|NoPractice|NoPractice|NoPractice|0.0|188",
"委内瑞拉玻利瓦尔共和国|NoPractice|NoPractice|NoPractice|NoPractice|0.0|188",
"也门共和国|NoPractice|NoPractice|NoPractice|NoPractice|0.0|188"
    ],
    vals2:["Austria|0|0|0|0|100.0|1",
"Belgium|0|0|0|0|100.0|1",
"Czech Republic|0|0|0|0|100.0|1",
"Denmark|0|0|0|0|100.0|1",
"France|0|0|0|0|100.0|1",
"Hungary|0|0|0|0|100.0|1",
"Italy|0|0|0|0|100.0|1",
"Luxembourg|0|0|0|0|100.0|1",
"Netherlands|0|0|0|0|100.0|1",
"Poland|0|0|0|0|100.0|1",
"Portugal|0|0|0|0|100.0|1",
"San Marino|0|0|4|50|97.5|20",
"Slovak Republic|0|0|0|0|100.0|1",
"Slovenia|0|0|0|0|100.0|1",
"Spain|0|0|0|0|100.0|1",
"Croatia|0|0|0|0|100.0|1",
"Romania|0|0|0|0|100.0|1",
"Hong Kong SAR, China|1|0|19|266|95.0|29",
"Switzerland|1|115|1|115|96.1|26",
"United States|1.5|175|1.5|175|92.0|39",
"United States Los Angeles|2|175|2|175|92.0|39",
"United States New York City|2|175|2|175|92.0|39",
"Sweden|2|55|0|0|98.0|18",
"Canada|2|167|2|172|88.4|51",
"Estonia|2|0|0|0|99.9|17",
"Norway|2|125|2|125|97.0|22",
"Eswatini|2|134|3|134|92.9|35",
"Moldova|3|76|4|83|92.3|38",
"Kosovo|4|105|6|128|94.2|31",
"Lesotho|4|150|5|150|91.9|40",
"Serbia|4|47|5|52|96.6|23",
"Bulgaria|4|55|1|0|97.4|21",
"Bhutan|5|59|5|110|94.2|30",
"Botswana|5|317|4|98|86.7|55",
"Kyrgyz Republic|5|10|69|499|74.7|89",
"Bosnia and Herzegovina|5|70|6|109|95.7|27",
"Georgia|6|112|15|396|90.1|45",
"Morocco|6|156|57|228|85.6|58",
"Ukraine|6|75|32|100|80.1|74",
"West Bank and Gaza|6|51|6|50|86.7|54",
"Lithuania|7|58|0|0|97.8|19",
"Belarus|7|65|0|0|96.5|24",
"Montenegro|8|85|23|306|91.9|41",
"North Macedonia|9|103|8|150|93.9|32",
"Albania|9|55|10|77|96.3|25",
"Lao PDR|9|140|11|224|78.1|78",
"Turkey|10|338|7|46|91.6|44",
"Singapore|10|335|33|220|89.6|47",
"Nepal|11|103|11|190|85.1|60",
"Tunisia|12|375|80|596|74.6|90",
"Korea, Rep.|13|185|6|315|92.5|36",
"Kenya|16|143|194|833|67.4|117",
"Dominican Republic|16|488|24|579|83.5|66",
"Taiwan, China|17|335|47|340|84.9|61",
"Azerbaijan|17|214|14|300|77.0|83",
"China Shanghai|18|249|37|230|87.2|56",
"Cyprus|18|300|15|335|88.4|50",
"Costa Rica|20|450|80|500|77.6|80",
"Mexico|20.4|400|44.2|450|82.1|69",
"Mexico Mexico City|20|400|44|450|82.1|69",
"Mexico Monterrey|20|400|44|450|82.1|69",
"China|20.7|256.2|35.7|241|86.5|56",
"Argentina|21|150|60|1,200|67.1|119",
"China Beijing|24|265|34|255|85.7|56",
"El Salvador|24|128|36|128|89.8|46",
"Greece|24|300|1|0|93.7|34",
"Ireland|24|305|24|253|87.2|52",
"Latvia|24|150|0|0|95.3|28",
"Malta|24|370|2|230|88.9|48",
"Mauritius|24|303|41|372|81.0|72",
"Panama|24|270|24|490|85.5|59",
"United Kingdom|24|280|3|0|93.8|33",
"Qatar|25|382|48|558|71.5|101",
"Japan Osaka|26|331|24|389|85.3|57",
"Tajikistan|27|313|107|223|60.9|141",
"Armenia|27|100|3|0|91.7|43",
"Japan|26.7|272.4|39.6|314.8|85.9|57",
"Japan Tokyo|27|241|48|275|86.3|57",
"St. Kitts and Nevis|27|335|37|311|81.0|71",
"St. Lucia|27|718|27|842|73.9|93",
"United Arab Emirates|27|462|54|553|74.1|92",
"Oman|28|279|39|244|84.1|64",
"Haiti|28|368|83|563|76.9|85",
"Malaysia|28|213|36|213|88.5|49",
"St. Vincent and the Grenadines|28|340|48|540|77.4|81",
"Uzbekistan|32|278|111|278|58.2|152",
"Australia|36|766|39|539|70.3|106",
"Bahamas, The|36|512|51|1,385|53.1|161",
"Dominica|36|625|39|906|74.3|91",
"Finland|36|213|2|0|92.4|37",
"Germany|36|345|0|0|91.8|42",
"Guatemala|36|310|72|405|77.2|82",
"Iceland|36|365|24|365|86.7|53",
"Israel|36|150|64|307|83.4|67",
"Micronesia, Fed. Sts.|36|168|56|180|84.0|65",
"New Zealand|37|337|25|367|84.6|63",
"Saudi Arabia|37|319|72|464|76.0|86",
"Vanuatu|38|709|126|681|59.1|148",
"Barbados|41|486|81|1,776|62.8|132",
"Maldives|42|596|100|981|55.9|157",
"Papua New Guinea|42|700|72|940|65.8|125",
"Philippines|42|456|120|690|68.4|113",
"Sri Lanka|43|366|72|300|73.3|96",
"Somalia|44|495|85|952|51.6|166",
"Thailand|44|223|50|233|84.6|62",
"Afghanistan|48|453|96|750|30.6|177",
"Bolivia|48|65|114|315|71.6|100",
"Cambodia|48|375|8|240|67.3|118",
"Egypt, Arab Rep.|48|258|240|554|42.2|171",
"Niger|48|391|78|462|65.4|126",
"Peru|48|630|72|700|71.3|102",
"Puerto Rico (U.S.)|48|386|48|386|81.9|70",
"Mali|48|242|98|545|73.3|95",
"Brazil|49|862|30|375.0|69.9|108",
"Brazil Rio de Janeiro|49|862|30|375|69.9|108",
"Brazil São Paulo|49|862|30|375|69.9|108",
"India Mumbai|50|231|60|273|82.2|68",
"Comoros|51|651|70|765|66.9|120",
"Ethiopia|51|172|72|120|56.0|156",
"Indonesia Jakarta|51|207|80|384|69.3|116",
"Samoa|51|1,400|84|900|57.8|154",
"Tonga|52|201|26|330|72.6|97",
"India|52.1|211.9|65.3|266.1|82.5|68",
"Jordan|53|131|79|206|79.0|75",
"India Delhi|54|195|70|260|82.7|68",
"Sierra Leone|55|552|120|821|51.9|165",
"Vietnam|55|290|56|373|70.8|104",
"Fiji|56|317|35|320|77.9|79",
"Indonesia|56.3|211.1|99.4|382.6|67.5|116",
"Jamaica|58|876|80|906|61.5|136",
"Pakistan|58|288|120|287|68.8|111",
"Pakistan Karachi|58|288|120|287|68.8|111",
"Pakistan Lahore|58|288|120|287|68.8|111",
"Burundi|59|109|154|444|47.3|169",
"Bahrain|59|47|42|397|78.7|77",
"Uganda|59|209|145|447|66.7|121",
"Chile|60|290|54|290|80.6|73",
"Marshall Islands|60|298|84|298|78.9|76",
"Trinidad and Tobago|60|499|78|635|62.6|134",
"Antigua and Barbuda|61|546|61|546|68.7|112",
"Senegal|61|547|53|702|60.9|142",
"Mauritania|62|749|69|580|60.3|144",
"Mozambique|66|602|9|399|73.8|94",
"Russian Federation|66|580|30|520.0|71.8|99",
"Russian Federation Moscow|66|580|12|400|74.0|99",
"Russian Federation Saint Petersburg|66|580|72|800|66.5|99",
"Togo|67|163|168|612|63.7|131",
"Madagascar|70|868|99|595|61.0|140",
"Cabo Verde|72|641|60|588|69.1|109",
"Djibouti|72|605|118|1,055|59.4|147",
"Guinea|72|778|79|809|47.8|167",
"Guyana|72|468|84|265|58.3|151",
"Kiribati|72|420|96|685|62.1|135",
"Libya|72|575|79|637|64.7|129",
"Nicaragua|72|240|72|400|77.0|84",
"Burkina Faso|75|261|102|265|66.6|122",
"Indonesia Surabaya|75|225|168|376|61.3|116",
"Benin|78|354|82|599|68.9|110",
"Malawi|78|243|55|143|65.3|127",
"Algeria|80|593|210|409|38.4|172",
"Seychelles|82|332|97|341|71.8|98",
"São Tomé and Príncipe|83|426|150|406|66.0|124",
"Rwanda|83|183|74|282|75.0|88",
"Kuwait|84|665|72|634|52.6|162",
"Suriname|84|468|48|658|75.0|87",
"Syrian Arab Republic|84|1,113|141|828|29.8|178",
"Iraq|85|1,118|131|644|25.3|181",
"Zimbabwe|88|285|228|562|54.3|159",
"South Africa|92|1,257|87|676|59.6|145",
"Belize|96|710|30|688|68.2|114",
"Ecuador|96|560|24|250|71.2|103",
"Gabon|96|1,633|84|1,320|43.9|170",
"Lebanon|96|480|180|790|57.9|153",
"Tanzania|96|1,175|402|1,350|20.2|182",
"Timor-Leste|96|350|100|410|69.9|107",
"Uruguay|96|1,038|6|500|58.4|150",
"Iran, Islamic Rep.|101|415|141|660|66.2|123",
"Grenada|101|1,034|37|1,256|61.5|137",
"Palau|102|505|84|605|61.0|139",
"Kazakhstan|105|470|2|0|70.4|105",
"Chad|106|319|242|965|37.0|173",
"Ghana|108|490|80|553|54.8|158",
"Honduras|108|601|96|483|64.3|130",
"Gambia, The|109|381|87|326|67.8|115",
"Solomon Islands|110|630|108|740|53.4|160",
"Colombia|112|630|112|545|62.7|133",
"Brunei Darussalam|117|340|48|395|58.7|149",
"Guinea-Bissau|118|585|84|550|59.6|146",
"Namibia|120|745|6|145|61.5|138",
"Paraguay|120|815|24|500|65.1|128",
"Zambia|120|370|120|380|56.9|155",
"Nigeria|128.4|785.7|241.7|1,076.8|29.2|179",
"Nigeria Kano|128|786|242|1,077|29.2|179",
"Nigeria Lagos|128|786|242|1,077|29.2|179",
"Equatorial Guinea|132|760|240|985|32.0|175",
"Mongolia|134|225|48|210|60.8|143",
"Central African Republic|141|280|122|709|52.4|164",
"Myanmar|142|432|230|457|47.7|168",
"South Sudan|146|763|179|781|26.2|180",
"Angola|164|825|72|1,030|36.2|174",
"Bangladesh|168|408.2|216|900|31.8|176",
"Bangladesh Chittagong|168|408|216|900|31.8|176",
"Bangladesh Dhaka|168|408|216|900|31.8|176",
"Sudan|180|967|144|1,093|19.0|185",
"Liberia|193|1,113|217|1,013|19.2|184",
"Cameroon|202|983|271|1,407|16.0|186",
]
}
export default {
    data(){
        return{
            //2,3,4,5,13,10,11,12,n11,n12,7,v14,v15,v16,v17,8,n19,n20,n21,17,n23,15,n25,n26,n27,n28
            debug: configdata.debug,
            hotAlpha: configdata.hotAlpha,
            path: configdata.path,
            bgm: configdata.bgm,
            res: configdata.res,
            datas: configdata.datas,
            ui: configdata.ui,
            hots: configdata.hots,
            uipp: configdata.uipp,
            isOfficial: configdata.isofficial,
            vals: configdata.vals,
            vals2: configdata.vals2,

            popnam: '',
            ctime: '00:00',
            ttime: '01:00',
            kw: '',
        }
    },
    mixins: [basefunc],
    computed:{
        vidsrc(){
            return this.path+this.lang+this.datas[this.cur].name+'.'+this.datas[this.cur].type
        },
        svidsrc(){//官网版需把视频放到obs,并删掉public多余的视频
            if(!this.isOfficial)
                return this.path+this.lang+'s'+this.datas[this.cur].name+'.'+this.datas[this.cur].type
            else
                return 'https://panstone-share.obs.cn-south-1.myhuaweicloud.com/xw/JZone/ph2/'+'s'+this.datas[this.cur].name+'.'+this.datas[this.cur].type

        },
        curname(){
            return this.datas[this.cur].name
        },

        ...mapState('app',['cur','lang'])
    },
    
    components:{
        Vid,
        HotPP,
        Pop,
        Breath,
        ProgressBar,
        Info
    },
    mounted(){
        // load config
        /*axios.get(config).then(response=>{
            const result = response.data
            //this.something = data
            this.assets = result.assets
        })*/
        // set up resize service and keyservice
        FontService.getInstance()
        //KeyService.getInstance().add('c', this.showControl)
        KeyService.getInstance().updateF(this.$el)
        ResizeService.getInstance().updateDirection(`r${this.res.x}x${this.res.y}`)
        this.initDatas()

        KeyService.getInstance().add('space',this.simpp)
        KeyService.getInstance().add('down',this.simnext)
        KeyService.getInstance().add('up',this.simprev)
        KeyService.getInstance().add('esc',this.handleUI.bind(this,'sock','exit'))

        // this.setNam('map')
    },
    methods:{
        //showControl(){
            //console.log('add your control here like following')
            //window.open('/#/D1_3_Control','_blank')
        //},
        initDatas(){
            let s=''
            this.datas.map(item=>s+=item.name+'_')
            console.log(s)
            //三朵云需取消这里
            if(!configdata.isc3){
                this.setLang(configdata.startLan) 
                this.$refs['hotpp0'][0].setSelected(true)
            }
        },
        
        onPlayEnd(){
            if(this.datas[this.cur].next!=="")this.setNam(this.datas[this.cur].next)
        },
        setNam(nam){
            let c=-1
            this.datas.map((item,id)=>{
                if(item.name===nam) c=id
            })
            if(c!==-1){
                this.dealCur(c)
            }
        },
        dealCur(n){
            if(n>=0&&n<this.datas.length)this.setCur(n)
        },
        handleUI(cmd,arg){
            console.log(cmd,arg)
            if(cmd==='home') this.dealCur(0)
            else if(cmd==='prev') this.dealCur(this.cur-1)
            else if(cmd==='next') this.dealCur(this.cur+1)
            else if(cmd==='back') this.setNam(arg)
            else if(cmd==='sock'&&arg==='exit') {window.opener=null;window.close()}
            else if(cmd==='sock')SocketService.getInstance().emit('j',{val:arg}) 
            
        },
        handleHot(cmd,arg){
            console.log(cmd,arg)
            if(cmd==='hot')this.setNam(arg)
            else if(cmd==='pop') {
                this.$refs.pop.showPop(true)
                this.popnam=arg
            }else if(cmd==='sock')SocketService.getInstance().emit('j',{val:arg})
        },
        onback(){
            this.$refs.pop.showPop(false)
        },
        handleUIPP(cmd,arg,id){
            console.log(cmd,arg)
            // console.log(this.$refs['hotpp'+id][0].getSelected())
            const args=arg.split('|')
            if(cmd==='lang'&&args.length>=2) this.setLang(this.$refs['hotpp'+id][0].getSelected()?args[1]:args[0])
            else if(cmd==='vctl') {
                if(!this.$refs['hotpp'+id][0].getSelected())this.$refs['vids'].pause()
                else this.$refs['vids'].resume()
            }
            
        },
        simpp(){
            if(!this.$refs['hotpp1'][0].getSelected()){
                this.$refs['vids'].pause()
                this.$refs['hotpp1'][0].setSelected(true)
            }else {
                this.$refs['vids'].resume()
                this.$refs['hotpp1'][0].setSelected(false)
            }
        },
        simnext(){
            if('1_3_4_5_12_14_15_17_22_24_26_28_30'.split('_').indexOf(this.curname)!==-1)this.dealCur(this.cur+1)
        },
        simprev(){
            if('3_4_5_9_14_15_17_19_24_26_28_30_32'.split('_').indexOf(this.curname)!==-1)this.dealCur(this.cur-1)
        },
        playSound(){
            this.$refs['sound'].play()
        },
        onSearch(){
            const rt=this.vals.filter(item=>item.indexOf(this.kw)!==-1)
            console.log(rt)
        },
        
        ...mapMutations('app',['setLang','setCur'])
    }

}
</script>

<style lang="sass" scoped>
@import '@/styles/common'
@import '@/styles/edge'
.content
    +full()
    display: flex
    justify-content: center
    align-items: center
    overflow: hidden
    .res
        background: #000
        .cover
            +full()
        .phone
            position: absolute
            +size(416,898)
            +pos(834,97)
            // background: #f00
            overflow: hidden
            border-radius: pxToRem(56)
            video
                object-fit: contain
                +size(416,898)

        .ui,.hot
            position: absolute
            top: 0
            left: 0
            li
                +contain()
                cursor: pointer
        
        .pop
            .back
                position: absolute
                background: #f006
                +size(100,100)
                +pos(0,0) 
                cursor: pointer   
        .gtime
            position: absolute
            +size(100,40)
            color: #000
            +pos(1600,1010)
            line-height: pxToRem(40)
        .arr
            +size(132,212)
            +pos(3615,974)
        // .pbg
        //     position: absolute
        //     +pos(0,894)   
        

    .g1
        .bt1
            +pos(145,1773)
            +size(283,135)
        .bt2
            +pos(145,1907)
            +size(283,135)
        .bt3
            +pos(816,969)
            +size(448,204)
        .bt4
            +pos(2739,793)
            +size(783,308)
        .bt5
            +pos(1053,760)
            +size(694,248)
        .ho
            transition: all .5s
            &:hover
                opacity: .5
    .g0
        font-size: pxToRem(48)
        font-family: HuaweiSansB
        .title
            +pos(719,1922)
            +size(2401,167)
        .title1,.title1a
            +pos(422,1926)
            +size(793,165)
        .title2,.title2a
            +pos(1157,1926)
            +size(790,165)
        .title3,.title3a
            +pos(1892,1926)
            +size(790,165)
        .title4,.title4a
            +pos(2628,1926)
            +size(754,165)
        .title1a,.title2a,.title3a,.title4a
            opacity: 0
            transition: all .5s
            color: black
            &:hover
                opacity: 1
        .box1
            +size(360,80)
            +pos(1850,1264-86)
            transform: skewY(-29deg)
        .box2
            +size(410,84)
            +pos(1312,463+60)
            transform: skewY(17deg)
        .box3
            +size(510,60)
            +pos(46,352-45)
            transform: skewY(-12deg)
        .box4
            +size(620,84)
            +pos(2179,790+90)
            transform: skewY(17deg)
.inputfield
    +size(660,157)
    +pos(3000,50)
    display: flex
    align-items: center
.input1
    font-size: pxToRem(50)
    margin: pxToRem(50) pxToRem(75)
    // background: #f006
    width: pxToRem(400)
.isearch
    +size(52,53)
    margin-left: pxToRem(10)    
</style>